interface ICookiesOptions {
	[key: string]: unknown;
}

export const cookies = {
	set(name: string, value: string, options: ICookiesOptions = {}) {
		options = {
			path: '/',
			...options,
		};

		if (options.expires instanceof Date) {
			options.expires = options.expires.toUTCString();
		}

		let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

		for (const optionKey in options) {
			if (options.hasOwnProperty(optionKey)) {
				updatedCookie += '; ' + optionKey;
				const optionValue = options[optionKey];
				if (optionValue !== true) {
					updatedCookie += '=' + optionValue;
				}
			}
		}

		document.cookie = updatedCookie;
	},

	get(name: string) {
		const matches = document.cookie.match(new RegExp(
			'(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)',
		));
		return matches ? decodeURIComponent(matches[1]) : undefined;
	},

	delete(name: string) {
		const hostname = location.hostname;
		let domain = '';

		if (hostname === 'localhost') {
			domain = 'localhost';
		} else {
			domain = hostname
				.split('.')
				.splice(-2)
				.join('.');
		}

		this.set(name, '', {
			'max-age': -1,
			'expires': new Date('Thu, 01 Jan 1970 00:00:00 GMT'),
			domain,
			'path': '/',
		});
	},
};
